<template>
  <div>
    <base-header type="" class="rsgradient pb-3 pb-1 pt-3 pt-md-5">
    </base-header>
    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">
        Transferencia CBU/CVU
      </b-card-header>

      <b-card-body v-if="!model.viewResult">
        <div class="row form-group">
          <div class="col-md-12" style="color: #ff5855">
            <label v-text="model.ContactName"></label>
          </div>

          <!--   <div class="col-md-12" style="font-weight: bolder">
                        <label v-text="model.BankName"></label>
                    </div> -->

          <div class="col-md-12">
            <label v-text="model.Alias"></label>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <div
              style="
                background-color: white;
                border-radius: 5px;
                border: #d6d4d4 1px solid;
              "
            />
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12" style="color: #ff5855; font-weight: bolder">
            <label>INGRESE IMPORTE Y REFERENCIA</label>
          </div>
        </div>
        <div class="row form-group">
          <div class="col-md-12">
            <money-with-indicator @data-loaded="setTransferReferencesList"
              v-model="model.Importe"
              :max-value="limiteDiarioDisponible"
            />
          </div>
          <div class="col-md-12" style="font-weight: bolder">
            <label v-text="model.Limit"></label>
          </div>
        </div>
        <!-- <div class="row form-group">
          <div class="col-md-12">
            <label>Referencia</label>
            <base-input
              v-model="model.Referencia"
              placeholder="Referencia"
            ></base-input>
          </div>
        </div> -->
         <div class="row form-group">
           <div class="col-md-12">
            <label>Referencia</label>
            <KitsCombo
              v-model="model.Referencia"
              v-bind:items="model.Referencias"
              propertyName="Description"
              propertyID="EntityID"
            ></KitsCombo>
          </div>
        </div>
        <div class="row form-group">
          <div class="col-md-12">
            <save-button
              text="Transferir"
              @click="transferir"
              :disabled="btnTransferirDisabled"
            />
          </div>
        </div>
      </b-card-body>

      <b-card-body v-if="model.viewResult">
        <div class="row">
          <div class="col-md-12 text-center">
            <base-alert :type="resultado.Tipo">
              <span class="alert-inner--icon" style="font-size: 60px">
                <i :class="resultado.Icono"></i> </span
              ><br />
              <span class="alert-inner--text" v-html="resultado.Texto"></span>
              <div v-show="resultado.ShowNextLevelText">
                <br />
                <span class="alert-inner--text">Hola! Desde Resimple queremos mejorar la seguridad, por eso vamos a solicitarte más información.</span>
                <br />
                <b-button class="btn btn-danger" @click="goToValidateIdentity" style="margin-top:10px;">Continuar</b-button>
              </div>
            </base-alert>
          </div>
          <div class="col-md-12">
            <div class="row text-center" style="margin-top: 10px">
              <div class="col-md-6 d-flex justify-content-end">
                <b-button class="btn btn-lg btn-danger" @click="goBack"
                  >Volver</b-button
                >
                 </div>
              <div class="col-md-6 d-flex justify-content-start" v-if="model.mostrarBtnDescargarComprobante">
                   <button
                    @click="descargarComprobante(model.receiptID)"
                    class="btn btn-success btn-sm"
                  >Descargar comprobante</button>
              </div>
            </div>
          </div>
          <div class="col-md-12" v-if="model.agregarDestinatario">
            <div class="row text-center" style="margin-top: 10px">
              <div class="col-md-12">
                <b-button class="btn btn-lg btn-success" @click="agregarDestinatario"
                  >Agregar Destinatario</b-button
                >
              </div>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
    <contact-help-desk
      ref="contact-help-desk"
      titleModal="Solicitud Rechazada"
    />
     <pin-validation ref="pin-validation"
            :showModal.sync="showModalPinValidation" 
            :accumulationMethodTypeID.sync="$store.getters.CASH_OUT_ATTEMPTS_METHODTYPE_ID"
            v-on:validPin="onValidPin" 
            v-on:loadUsePaymentPin="onLoadUsePaymentPin">
        </pin-validation>
    <modal-with-link ref="modal-with-link" />
  </div>
</template>

<style>
</style>

<script>
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";
import md5 from "js-md5";
import ContactHelpDesk from "@/views/ContactHelpDesk";
import MoneyWithIndicator from "@/components/Custom/MoneyWithIndicator";
import PinValidation from '@/views/Pin/PinValidation';
import ModalWithLink from "@/components/ModalWithLink.vue";
import KitsCombo from "@/components/KitsCombo";
import fileHelpers from "@/helpers/fileHelpers";

export default {
  components: {
    "modal-with-link": ModalWithLink,
    "contact-help-desk": ContactHelpDesk,
    "money-with-indicator": MoneyWithIndicator,
     "pin-validation": PinValidation,
     KitsCombo
  },
  props: {
    bankName: String,
    alias: String,
    cBUCVU: String,
    contactName: String,
    isAlias: Boolean,
    nameOwners: String,
    cuitCuilOwners: String
  },
  data() {
    return {
      model: {
        Importe: 0,
        Referencia: null,
        Referencias: [],
        BankName: this.bankName,
        Alias: this.alias,
        CBUCVU: this.cBUCVU,
        ContactName: this.contactName,
        IsAlias: this.isAlias,
        NameOwners: this.nameOwners,
        CuitCuilOwners: this.cuitCuilOwners,
        viewResult: false,
        Limit: "",
        agregarDestinatario: false,
        mostrarBtnDescargarComprobante: false,
        receiptID: 0
      },
      resultado: {
        Texto: "",
        Tipo: "danger",
        Icono: "fa fa-fw fa-thumbs-down",
        ShowNextLevelText: false,
      },
      helpDeskInformation: {
        Message: "",
        Show: false,
        ShowInfo: false,
        WhatsappUrl: "",
        PhoneNumber: "",
        EmailAddress: "",
        EmailSubject: "",
        MessageBody: "",
        ShowUnlockMail: false,
        Name: "",
        ShowContactarSoporte: false,
      },
      usePaymentPin: false,
      showModalPinValidation: false,
      btnTransferirDisabled: true,
      // Tope del input de Importe. Arranca en el mismo valor que el default
      // de MoneyWithIndicator y se actualiza con el límite diario real
      // apenas responde TransferenceOuterLimitRemain (ver mounted()).
      limiteDiarioDisponible: 9999999
    };
  },
  mounted() {
    let context = this;

    let req = {};
    axiosHelpers.axiosPost(
      "TransferenceContact/TransferenceOuterLimitRemain",
      { req },
      this,
      function (data) {
        context.model.Limit =
          "Limite diario disponible: " + data.ResponseVM.FormattedAmount;

          context.limiteDiarioDisponible = data.ResponseVM.Amount;
          context.btnTransferirDisabled = false;
      }
    );
  },
  methods: {
    setTransferReferencesList(transferReferencesList){
      this.model.Referencias = transferReferencesList;
      this.model.Referencia = transferReferencesList[0].EntityID;
    },
    goToValidateIdentity() {
      let context = this;
      context.$router.push("verificacionidentidad");
    },
    transferir() {
      let context = this;
      if (context.model.Importe == 0) {
        notificationHelpers.showWarning(
          "Advertencia!",
          "Complete el Importe",
          context
        );
        return;
      }
      this.pinValidate();

      // var hashTemp =
      //   (context.model.IsAlias == true ? "" : context.model.CBUCVU) +
      //   (context.model.IsAlias == true ? context.model.Alias : "") +
      //   context.model.Importe.toFixed(2) +
      //   context.model.Referencia;
      
      // var hashCalculado = md5(hashTemp);

      // let req = {
      //   Amount: context.model.Importe,
      //   Reference: context.model.Referencia,
      //   IsAlias: context.model.IsAlias,
      //   Alias: context.model.IsAlias == true ? context.model.Alias : "",
      //   CBUCVU: context.model.IsAlias == false ? context.model.CBUCVU : "",
      //   NameOwners: context.model.NameOwners,
      //   CuitCuilOwners: context.model.CuitCuilOwners,
      //   BankName: context.model.BankName,
      //   Hash: hashCalculado.toUpperCase(),
      //   DestinyCBUCVU: context.model.CBUCVU,
      // };

      // axiosHelpers.axiosPostWithoutAlerts(
      //   "TransferenceContact/TransferToExternalAccount",
      //   req,
      //   this,
      //   function (data) {
      //     context.model.viewResult = true;
      //     if (data.ResponseVM.LimitReached) {
      //       context.model.viewResult = false;
      //       context.helpDeskInformation.Show = true;
      //       context.helpDeskInformation.ShowContactarSoporte = true;
      //       context.helpDeskInformation.Message = data.Alerts[0].Message;
      //       context.helpDeskInformation.EmailAddress =
      //         context.$store.getters.EmailAddress;
      //       context.helpDeskInformation.EmailSubject =
      //         context.$store.getters.EmailSubject;
      //       context.helpDeskInformation.MessageBody =
      //         context.$store.getters.MessageBody;
      //       context.helpDeskInformation.UrlWhatsapp =
      //         context.$store.getters.UrlWhatsapp;
      //       context.helpDeskInformation.PhoneNumber =
      //         context.$store.getters.PhoneNumber;
      //       context.$refs["contact-help-desk"].setHelpDeskInformation(
      //         context.helpDeskInformation
      //       );
      //     } else {
      //       if (data.ResponseVM.IsSuccess) {
      //         let msg =
      //           "Operacion realizada con exito." +
      //           "<br/>" +
      //            "Transferencia Realizada.";

      //         context.resultado = {
      //           Texto: msg,
      //           Tipo: "success",
      //           Icono: "fa fa-fw fa-thumbs-up",
      //           ShowNextLevelText: data.ResponseVM.CloseToExceedingLimit
      //         };

      //         // -- Si no existe el Destinatario
      //         if(!data.ResponseVM.Destinatario.ContactoExistente)
      //         {
      //             context.model.agregarDestinatario = true;
      //         }
      //       } else if (data.ResponseVM.IsPending) {
      //         let msg =
      //           "Operacion pendiente" +
      //           "<br/>" +
      //           "La transferencia esta demorada. Verifica el estado mas tarde";

      //         context.resultado = {
      //           Texto: msg,
      //           Tipo: "warning",
      //           Icono: "fa fa-fw fa-thumbs-up",
      //           ShowNextLevelText: data.ResponseVM.CloseToExceedingLimit
      //         };
      //       } else {
      //         let msg =
      //           "Ocurrio un error realizando la transferencia" +
      //           "<br/>" +
      //           data.Alerts[0].Message;

      //         context.resultado = {
      //           Texto: msg,
      //           Tipo: "danger",
      //           Icono: "fa fa-fw fa-thumbs-down",
      //         };
      //       }
      //     }
      //   }
      // );
    },
   
            
    goBack() {
      let context = this;
      context.$router.push("dashboard");
    },
    onValidPin(val) {
                if(val) {
                    this.transferirDinero();
                }
            },
            onLoadUsePaymentPin(val) {
                this.usePaymentPin = val;
            },
            pinValidate() {
                if(this.usePaymentPin) {
                    this.showModalPinValidation = true;
                } else {
                    this.transferirDinero();
                }
            },
    agregarDestinatario() {
      let context = this;
          this.$validator.validate().then(valid => {
          if (valid) {
              axiosHelpers.axiosPost(
                "TransferenceContact/CheckCBUCVUAccount",
                {
                    CBU: !context.model.IsAlias ? context.model.CBUCVU : '',
                    Alias: context.model.IsAlias ? context.model.Alias : ''
                },
                this,
                function(data) {
                if(data.Alerts.length == 0) {
                    data.ResponseVM.Contact.IsAlias = context.model.IsAlias;
                    context.$router.push({ 
                          name: "ConfirmarNuevoDestinatario", 
                          params: 
                          { 
                              propContact: data.ResponseVM.Contact,
                              propHash: data.ResponseVM.Hash
                          }
                        });
                      }
                  }
                );
                } else {
                    notificationHelpers.showWarning(
                        "Advertencia!",
                        "Verifique los campos",
                        context
                    );
                }
            });
        },
    onAvailableOK(val) {
      this.btnTransferirDisabled = !val;
    },
    descargarComprobante(receiptID) {
      let context = this;

      axiosHelpers.axiosGet(
        "Operation/ObtenerReporteComprobanteOperacion",
        { ComprobanteID: receiptID },
        this,
        function(data) {
          var bytesBase64 = data.ResponseVM.ContenidoArchivoReporte;

          var fileName = data.ResponseVM.NombreArchivoReporte;
          var contentType = "application/pdf";

          fileHelpers.downloadFile(context, bytesBase64, fileName, contentType);
        }
      );
    },
    transferirDinero(){
      let context=this;

      // Cargamos la descripcion de la referencia
      for (let i = 0; i < context.model.Referencias.length; i++) {
        if (context.model.Referencias[i].EntityID ===  context.model.Referencia) {
          context.model.Referencia = context.model.Referencias[i].Description;
        }
      }

       var hashTemp =
        (context.model.IsAlias == true ? "" : context.model.CBUCVU) +
        (context.model.IsAlias == true ? context.model.Alias : "") +
        context.model.Importe.toFixed(2) +
        context.model.Referencia;
      
      var hashCalculado = md5(hashTemp);

      context.model.mostrarBtnDescargarComprobante = false;

      let req = {
        Amount: context.model.Importe,
        Reference: context.model.Referencia,
        IsAlias: context.model.IsAlias,
        Alias: context.model.IsAlias == true ? context.model.Alias : "",
        CBUCVU: context.model.IsAlias == false ? context.model.CBUCVU : "",
        NameOwners: context.model.NameOwners,
        CuitCuilOwners: context.model.CuitCuilOwners,
        BankName: context.model.BankName,
        Hash: hashCalculado.toUpperCase(),
        DestinyCBUCVU: context.model.CBUCVU,
      };

      axiosHelpers.axiosPostWithoutAlertsForTransference(
        "TransferenceContact/TransferToExternalAccount",
        req,
        this,
        function (data) {
          context.model.viewResult = true;
          if (data.ResponseVM.LimitReached) {
            context.model.viewResult = false;
            context.helpDeskInformation.Show = true;
            context.helpDeskInformation.ShowContactarSoporte = true;
            context.helpDeskInformation.Message = data.Alerts[0].Message;
            context.helpDeskInformation.EmailAddress =
              context.$store.getters.EmailAddress;
            context.helpDeskInformation.EmailSubject =
              context.$store.getters.EmailSubject;
            context.helpDeskInformation.MessageBody =
              context.$store.getters.MessageBody;
            context.helpDeskInformation.UrlWhatsapp =
              context.$store.getters.UrlWhatsapp;
            context.helpDeskInformation.PhoneNumber =
              context.$store.getters.PhoneNumber;
            context.$refs["contact-help-desk"].setHelpDeskInformation(
              context.helpDeskInformation
            );
          } else {
            if (data.ResponseVM.IsSuccess) {
              context.model.receiptID = data.ResponseVM.ReceiptID;
              context.model.mostrarBtnDescargarComprobante = true;

              let msg =
                "Operacion realizada con exito." +
                "<br/>" +
                 "Transferencia Realizada.";

              context.resultado = {
                Texto: msg,
                Tipo: "success",
                Icono: "fa fa-fw fa-thumbs-up",
                ShowNextLevelText: data.ResponseVM.CloseToExceedingLimit
              };

              // -- Si no existe el Destinatario
              if(!data.ResponseVM.Destinatario.ContactoExistente)
              {
                  context.model.agregarDestinatario = true;
              }
            } else if (data.ResponseVM.IsPending) {
              let msg =
                "Operacion pendiente" +
                "<br/>" +
                "La transferencia esta demorada. Verifica el estado mas tarde";

              context.resultado = {
                Texto: msg,
                Tipo: "warning",
                Icono: "fa fa-fw fa-thumbs-up",
                ShowNextLevelText: data.ResponseVM.CloseToExceedingLimit
              };
            } else {
              var mensaje = 'Contactate con mesa de ayuda';
              if(data.Alerts.length > 0){
                mensaje = data.Alerts[0].Message;
              }

              let msg =
                "Ocurrio un error realizando la transferencia" +
                "<br/>" +
                mensaje;

              context.resultado = {
                Texto: msg,
                Tipo: "danger",
                Icono: "fa fa-fw fa-thumbs-down",
              };
            }
          }
        },
        function (message) {
          context.model.viewResult = true;
            context.model.viewResult = false;
            context.helpDeskInformation.Show = true;
            context.helpDeskInformation.ShowContactarSoporte = true;
            context.helpDeskInformation.Message = message;
            context.helpDeskInformation.EmailAddress =
              context.$store.getters.EmailAddress;
            context.helpDeskInformation.EmailSubject =
              context.$store.getters.EmailSubject;
            context.helpDeskInformation.MessageBody =
              context.$store.getters.MessageBody;
            context.helpDeskInformation.UrlWhatsapp =
              context.$store.getters.UrlWhatsapp;
            context.helpDeskInformation.PhoneNumber =
              context.$store.getters.PhoneNumber;
            context.$refs["contact-help-desk"].setHelpDeskInformation(
              context.helpDeskInformation
            );                     
         },
        function (message) {
          context.$refs["modal-with-link"].showModalWithParams(
            "Solicitud Rechazada",
            message,
            "verificacionidentidad",
            "Continuar"
          );                  
         }
      );
    }
  },
};
</script>